
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { apiRequest } from '../_helpers/apiConfig';
import { refCounts } from './preferenceSlice';



export const getReferralList = createAsyncThunk("/admin/ref_list", async (filters) => {
    const response = await apiRequest('POST', '/v1/admin/ref_list', filters);
    return response;
});


export const createReferral = createAsyncThunk("/admin/createrefferal",
    async (arg, thunkAPI) => {
        const { Payload, forReferesh } = arg;

        const response = await apiRequest("POST", "v1/admin/createrefferal", Payload);
        if (response.message) {
            thunkAPI.dispatch(getReferralList(forReferesh));
        }
        return response;
    }
);

export const deleteReferral = createAsyncThunk("/admin/ref_delete",
    async (arg, thunkAPI) => {
        const { Payload, forReferesh } = arg;

        const response = await apiRequest("POST", "v1/admin/ref_delete", Payload);
        if (response.message) {
            thunkAPI.dispatch(getReferralList(forReferesh));
            thunkAPI.dispatch(refCounts());
        }
        return response;
    }
);


export const toggleReferral = createAsyncThunk("/admin/refferToogle",
    async (arg, thunkAPI) => {
        const { Payload, forReferesh } = arg;

        const response = await apiRequest("POST", "v1/admin/refferToogle", Payload);
        if (response.message) {
            thunkAPI.dispatch(getReferralList(forReferesh));
            thunkAPI.dispatch(refCounts())
        }
        return response;
    }
);



const referralAndRewardSlice = createSlice({
    name: 'referral&reward',
    initialState: {
        referralData: [],
        referralDataCreated: [],
        referralDelete: null,
        totalReferralData: null,

        loading: false,
        error: null,

    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(getReferralList.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(getReferralList.fulfilled, (state, action) => {
                state.loading = false;
                state.referralData = action?.payload?.data?.list;
                state.totalReferralData = action?.payload?.data?.total;

            })
            .addCase(getReferralList.rejected, (state, action) => {
                state.loading = false;
                state.error = action.error.message;
            })

            .addCase(createReferral.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(createReferral.fulfilled, (state, action) => {
                state.loading = false;
                state.referralDataCreated = action?.payload

            })
            .addCase(createReferral.rejected, (state, action) => {
                state.loading = false;
                state.error = action.error.message;
            })

            .addCase(deleteReferral.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(deleteReferral.fulfilled, (state, action) => {
                state.loading = false;
                state.referralDelete = action?.payload

            })
            .addCase(deleteReferral.rejected, (state, action) => {
                state.loading = false;
                state.error = action.error.message;
            })


            .addCase(toggleReferral.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(toggleReferral.fulfilled, (state, action) => {
                state.loading = false;
                state.referralDelete = action?.payload

            })
            .addCase(toggleReferral.rejected, (state, action) => {
                state.loading = false;
                state.error = action.error.message;
            })








    },
});

export default referralAndRewardSlice.reducer;